export default {
  data() {
    return {
      activeIndex: 0,
      tabsList: [{
        label: "国内头部广告联盟",
        title: "高效的聚合能力",
        content: "AdJM全面兼容全球优质资源，开发者可以在一个平台上接入多家广告联盟，大大减少接入时间和成本。"
      }, {
        label: "海外主流广告联盟",
        title: "全球资源整合",
        content: "整合Facebook、Google等海外主流广告平台，为出海应用提供优质的广告变现解决方案。"
      }, {
        label: "自营广告平台",
        title: "专业服务保障",
        content: "自营广告平台提供更稳定的收益保障，专业的运营团队确保最佳的变现效果。"
      }]
    };
  },
  methods: {
    getImagePath(index) {
      return require(`../../assets/images/p-${index + 1}.jpg`);
    },
    selectTab(index) {
      if (index !== this.activeIndex) {
        this.activeIndex = index;
      }
    },
    onEnter(el, done) {
      // 进入动画 - 淡入
      el.style.opacity = "0";
      el.style.transition = "opacity 0.3s ease-in-out";

      // 强制重绘
      el.offsetHeight;
      el.style.opacity = "1";
      setTimeout(done, 300);
    },
    onLeave(el, done) {
      // 离开动画 - 淡出
      el.style.transition = "opacity 0.1s ease-in-out";
      el.style.opacity = "0";
      setTimeout(done, 100);
    }
  }
};